import { SECTION_DEFINITIONS } from "../constants";

export function adaptSectionTitleSettings(
	settings: CMSSetting[]
): SectionTitleSetting[] {
	const settingsMap = new Map<string, string | boolean>();
	for (const setting of settings) {
		settingsMap.set(setting.name, setting.value);
	}

	return SECTION_DEFINITIONS.map((def) => ({
		key: def.key,
		label: def.label,
		title: (settingsMap.get(def.titleSettingName) as string) ?? "",
		shown:
			settingsMap.get(def.shownSettingName) === true ||
			settingsMap.get(def.shownSettingName) === "true"
	}));
}
